 <template>
  <div class="app-container">
    <el-dialog
      :title="title"
      :visible="visible"
      :width="width"
      append-to-body
      modal
      @close="handleCloes"
    >
      <BjPage
        ref="BjPage"
        :get-action="queryApi"
        :query-params="queryParams"
        :col-span="colSpan"
        :search-btn-span="colSpan"
        :serial="serial"
        :search-btn-hide="false"
        :before-reset-search="beforeResetSearch"
        :height="500"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')">
             <BjSelectLov v-model="queryParams.status" :placeholder="$t('table.statusText')" :option-list="IMPORT_STATUS" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('reasonText')">
            <BjInput v-model="queryParams.errorReason" :maxlength="MAX_LENGTH.REMARK" :placeholder="$t('reasonText')" @keyup.enter.native="handleQuery"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'dataStatus'">
                {{ $t(IMPORT_STATUS.bjGet(scope.row.dataStatus)) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi } from '@/api';
export default {
  name: 'BusinessThirdAfterExportHistory',
  mixins: [pageMiXin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: '50%',
    },
  },
  data() {
    return {
      colSpan: 8,
      queryApi: goodsApi.getSkuImportRecord,
      // 查询参数
      queryParams: {},
      labelList: [
        { label: 'table.statusText', prop: 'dataStatus', isCheck: true, disabled: false,},
        { label: 'reasonText', prop: 'errorMsg', isCheck: true, disabled: false,},
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false,},
      ],
      IMPORT_STATUS: [
        { label: this.$t('goodsPage.ERROR'), value: 'ERROR' },
        { label: this.$t('goodsPage.SUCCESS'), value: 'IMPORT_SUCCESS' },
        { label: this.$t('goodsPage.FAILED'), value: 'IMPORT_FAILED' },
      ],
      timer: null
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: false,
      handler(v) {
        if (v) {
         this.queryParams.errorReason = null;
         this.queryParams.status = null;
         this.$nextTick(() => {
           this.$refs.BjPage.fetchData();
         });
      }
      }
    },
  },
  destroyed() {
    if(this.timer){
      clearInterval(this.timer)
    }
  },
  methods: {
    // 页面轮询
    timeON(){
      this.timer = setInterval(()=>{
        this.$refs.BjPage.fetchData();
      },2000)
    },
    // 终止轮询
    timeOff(){
      if(this.timer){
        clearInterval(this.timer)
      }
    },
    // async getCurrencyList(id) {
    //   const res = await baseDataApi.getLovValuesByLovId({lovId: id, size: 999 });
    //   this.CURRENCY_LIST = res.content.map(item => {
    //     return {
    //       label: item.meaning,
    //       value: item.value
    //     };
    //   });
    // },
    beforeResetSearch() {
      this.queryParams.status = null;
      this.queryParams.errorReason = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    handleCloes() {
      this.timeOff();
      this.$emit('close');
    },
  }
};
</script>
